import styled from "styled-components";

export const OrdersDetailsContainer = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;

  padding: 2rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 1.5rem;
  }
`;

export const OrderAlignModalButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 0.75rem;
  margin-top: 0.75rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    width: 100%;
    flex-direction: column;
    margin-bottom: 0.75rem;
  }
`;

export const LoadingContainer = styled.div`
  height: calc(100vh - 21rem);

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OrderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${(props) => props.theme.colors["blue-600"]};
  font-size: ${(props) => props.theme.fontSize.XXXS};
  color: ${(props) => props.theme.newColors["white-300"]};
  border: none;
  border-radius: 0.5rem;

  padding: 0.5rem 0.75rem;

  height: 2rem;
  min-width: 9rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    height: 2.5rem;
    width: 100%;
  }

  &:hover:enabled {
    background-color: ${(props) => props.theme.newColors["blue-700"]};
    transition: all 0.2s;
  }
`;
